const OurProcess = () => {
  return (
    <section id="process" className="section-padding">
      <div className="container text-center">
        <h3 className="mt-sm">
          How It <span className="text-light">Works</span>
          <span style={{ color: "#e6ae49" }}>.</span>
        </h3>
        <p className="lead">
          From your first message to a live, selling store.
        </p>
      </div>
      <div className="container text-center">
        <div className="row">
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.2s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step1 - Skype Interview"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-headset" />
              </div>
              <h5>We have a quick conversation</h5>
              <p>
                We ask a few simple questions about your business and recommend
                the right package.
                <br />
                <br />
                Your effort: 15 minutes
                <br />
                (Day 1).
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.4s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step2 - Project Plan"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-book-pencil" />
              </div>
              <h5>You pay ₹5,000 to get started</h5>
              <p>
                Pay a small advance and share onboarding details like logo,
                products, and preferences.
                <br />
                <br />
                Your effort: 20 minutes <br />
                (Day 1).
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step3 - Design"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-picture-multiple" />
              </div>
              <h5>We build your store - you do nothing</h5>
              <p>
                We handle setup, theme, products, payments, domain connection,
                and SEO.
                <br />
                <br />
                Your effort: Zero
                <br />
                (Day 1 to Day 4).
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.8s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step4 - Development"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-gear" />
              </div>
              <h5>You review your store on a preview link</h5>
              <p>
                You check the full experience and request changes, which we
                implement quickly.
                <br />
                <br />
                Your effort: 30 minutes
                <br />
                (Day 4 to Day 5).
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="1s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step5 - Testing"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-ecommerce-graph3" />
              </div>
              <h5>Your store goes live - balance payment due</h5>
              <p>
                Once approved, we launch on your domain and share a walkthrough
                video.
                <br />
                <br />
                Your effort: watch a 5-minute video
                <br />
                (Day 5 to Day 7).
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="1.2s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step6 - Delivery"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-anticlockwise" />
              </div>
              <h5>We stay with you after launch for support</h5>
              <p>
                We provide post-launch support for fixes, updates, and smooth
                ongoing performance.
                <br />
                <br />
                Support: 3 to 14 days
                <br />
                (package dependent).
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurProcess;
